// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__EkKEv","colCheckbox":"styles_colCheckbox__3xZhH"};